<template>
  <div>
    <label class="titlePage">Alterações</label>

    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="alteracoes"
      :porPage="itemsPorPage"
      @row-selected="selecionaLinha"
    />

    <div class="text-right mb-3">
      <fccButton>{{ labelsSystem.excluir }}</fccButton>
    </div>
  </div>
</template>
  <script>
export default {
  props: ['alteracoes'],
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'tecnico', label: 'Técnico', sortable: true },
        { key: 'dataimportacao', label: 'Data', sortable: true }
      ],
      itemsPorPage: '10',
      dadosSelecionados: []
    }
  },
  methods: {
    selecionaLinha(dados) {
      this.dadosSelecionados = dados
    }
  }
}
</script>